import PropTypes from "prop-types";
import React, { useRef } from "react";
import Rail from "web/react/components/rail/rail";
import analytics from "web/script/analytics/analytics";
import styles from "./related-searches-rail.module.css";

function RelatedSearchesRail({ title, relatedSearches, features = {}, source = null }) {
    let breadCrumbCount = 0;

    const railRef = useRef();

    function handleClick() {
        analytics.event("pdp_related_searches", "pdp_related_click", "related_search_clicked");
    }

    return (
        <Rail
            title={title}
            analyticsLabel="related_searches"
            className={styles.railWrapper}
            itemScope=""
            itemType="http://schema.org/BreadcrumbList"
            peekingCard={features.uj_peeking_card}
            smallRail={true}
        >
            <div ref={railRef} className={styles.railInner} data-source={source}>
                {relatedSearches.map((relatedSearch) => {
                    if (relatedSearch.is_breadcrumb) {
                        breadCrumbCount++;
                    }
                    return (
                        <div
                            className={styles.cardWrapper}
                            key={relatedSearch.url}
                            itemProp={relatedSearch.is_breadcrumb ? "itemListElement" : undefined}
                            itemScope={relatedSearch.is_breadcrumb ? "" : undefined}
                            itemType={
                                relatedSearch.is_breadcrumb
                                    ? "http://schema.org/ListItem"
                                    : undefined
                            }
                        >
                            <div className={styles.relatedSearchCard}>
                                <a
                                    href={relatedSearch.url}
                                    className={styles.relatedSearchTerm}
                                    itemProp={relatedSearch.is_breadcrumb ? "item" : undefined}
                                    onClick={handleClick}
                                >
                                    {relatedSearch.text}
                                </a>
                            </div>
                            {relatedSearch.is_breadcrumb && (
                                <meta itemProp="position" content={breadCrumbCount} />
                            )}
                        </div>
                    );
                })}
            </div>
        </Rail>
    );
}

RelatedSearchesRail.propTypes = {
    title: PropTypes.string,
    features: PropTypes.objectOf(PropTypes.string),
    relatedSearches: PropTypes.array.isRequired,
};

export default RelatedSearchesRail;
